"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopOff = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var desktop_1 = require("./desktop");

var DesktopOff = function DesktopOff() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(desktop_1.Desktop, null), react_1.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, react_1.default.createElement("path", {
    d: "M1.02999 0.507074L20.4928 19.9671L19.97 20.4899L16.6835 17.214L16.683 17.2134L5.78386 6.31597L5.78352 6.31562L0.507156 1.02982L1.02999 0.507074Z",
    stroke: "#FE4D4D"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: "clip0"
  }, react_1.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

exports.DesktopOff = DesktopOff;